export default function PlusIcon({ className }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_14269_17478)">
        <path d="M9.16797 9.16602V4.16602H10.8346V9.16602H15.8346V10.8327H10.8346V15.8327H9.16797V10.8327H4.16797V9.16602H9.16797Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_14269_17478">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>


  );
}
